// extracted by mini-css-extract-plugin
export var active = "_6w-7";
export var container = "_6w-0";
export var evenWidth = "_6w-4";
export var large = "_6w-5";
export var outlet = "_6w-8";
export var slide = "_6w-2";
export var small = "_6w-6";
export var tab = "_6w-3";
export var tabs = "_6w-1";